
import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Paper, Fade } from "@mui/material";
import { useLocation } from "react-router-dom";

import ResponseLayout from "./ResponseLayout";
import CalibrationLayout from "./CalibrationLayout";
import PredictionLayout from "./PredictionLayout";

export default function NavigationTabs() {
    const [activeTab, setActiveTab] = useState(0);

    const location = useLocation();

    const [calibrationRows, setCalibrationRows] = useState([]);
    const [calibrationResult, setCalibrationResult] = useState(null);

    /*
     * Open Prediction tab when another component navigates to
     * /microslide with:
     *
     * {
     *     state: {
     *         openPredictionTab: true,
     *         runId: entry.run
     *     }
     * }
     */
    useEffect(() => {
        if (location?.state?.openPredictionTab) {
            setActiveTab(0);
        }
    }, [location?.state?.openPredictionTab]);

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const tabs = [
        /*
        {
            label: "Response",
            component: <ResponseLayout />
        },
        */

        {
            label: "Calibration",
            component: (
                <CalibrationLayout
                    rows={calibrationRows}
                    setRows={setCalibrationRows}
                    setCalibrationResult={setCalibrationResult}
                />
            )
        },

        {
            label: "Prediction",
            component: (
                <PredictionLayout
                    calibrationRows={calibrationRows}
                    calibrationResult={calibrationResult}
                />
            )
        }
    ];

    return (
        <Paper
            elevation={1}
            sx={{
                width: "100%",
                margin: "10px",
                mt: 2,
                borderRadius: 2,
                overflow: "hidden"
            }}
        >
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: "divider"
                }}
            >
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    textColor="inherit"
                    indicatorColor="none"
                    sx={{
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "1rem",
                            minWidth: 200,
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            color: "white",
                            backgroundColor: "#774def",
                            transition: "none"
                        },

                        "& .MuiTab-root:hover": {
                            color: "white",
                            fontWeight: 600,
                            fontSize: "1.1rem",
                            backgroundColor: "#774def"
                        },

                        "& .Mui-selected": {
                            color: "white",
                            backgroundColor: "#774def",
                            boxShadow: "none"
                        },

                        "& .MuiTabs-indicator": {
                            display: "none"
                        }
                    }}
                >
                    {tabs.map((tab, index) => (
                        <Tab
                            key={index}
                            label={tab.label}
                        />
                    ))}
                </Tabs>
            </Box>

            <Box
                sx={{
                    position: "relative",
                    minHeight: 500,
                    overflow: "hidden"
                }}
            >
                {tabs.map((tab, index) => (
                    /*
                     * Keep both tabs mounted.
                     *
                     * This preserves:
                     * - Calibration state
                     * - Prediction state
                     * - Parameter changes
                     * - Spline changes
                     * - History state
                     *
                     * Only the active tab is displayed.
                     */
                    <Box
                        key={index}
                        sx={{
                            display:
                                activeTab === index
                                    ? "block"
                                    : "none",
                            width: "100%"
                        }}
                    >
                        <Fade
                            in={activeTab === index}
                            timeout={300}
                        >
                            <Box sx={{ width: "100%" }}>
                                {tab.component}
                            </Box>
                        </Fade>
                    </Box>
                ))}
            </Box>
        </Paper>
    );
}

